export default __webpack_public_path__ + "static/media/image3.8427ffa0.PNG";